import { getPublishedPosts, posts, type Post } from "./posts";
import { slugify } from "./slug";

export type TaxonomyTerm = {
  name: string;
  slug: string;
  count: number;
  posts: Post[];
};

function termsFromPosts(sourcePosts: Post[], selector: (post: Post) => string[]) {
  const termMap = new Map<string, TaxonomyTerm>();

  for (const post of sourcePosts) {
    for (const name of selector(post)) {
      const slug = slugify(name);
      const existing = termMap.get(slug);

      if (existing) {
        existing.count += 1;
        existing.posts.push(post);
      } else {
        termMap.set(slug, { name, slug, count: 1, posts: [post] });
      }
    }
  }

  return [...termMap.values()].sort((a, b) => a.name.localeCompare(b.name));
}

export function getCategories(includeFuture = false) {
  return termsFromPosts(includeFuture ? posts : getPublishedPosts(), (post) => [post.category]);
}

export function getTags(includeFuture = false) {
  return termsFromPosts(includeFuture ? posts : getPublishedPosts(), (post) => post.tags);
}

export function getCategory(slug: string) {
  return getCategories().find((category) => category.slug === slug);
}

export function getTag(slug: string) {
  return getTags().find((tag) => tag.slug === slug);
}
